import { IntersectionObserver } from 'foundations-components/transitional/components/IntersectionObserver';
import { useRef } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const BaseViewTracker = ({
  children,
  threshold = 0.25,
  trackOnce = true,
  usageTracker,
  onTrack
}) => {
  const hasTrackedRef = useRef(false);
  const handleIntersectionChange = ({
    observer,
    entries
  }) => {
    if (entries[0].isIntersecting && !hasTrackedRef.current) {
      if (trackOnce) {
        hasTrackedRef.current = true;
      }
      if (usageTracker) {
        onTrack(usageTracker.clone({
          standalone: true
        }));
      }
      observer.disconnect();
    }
  };
  return /*#__PURE__*/_jsx(IntersectionObserver, {
    onIntersectionChange: handleIntersectionChange,
    renderContent: () => children,
    threshold: threshold
  });
};